/* =========================================================
   EGO Hero Slider
   Version: 2.0.3

   Changelog
   ---------------------------------------------------------
   2.0.3
   - Added touch and pen swipe navigation for mobile devices.
   - Preserved vertical page scrolling and pinch zoom.
   - Ignored gestures beginning on interactive hero controls.
   - Paused autoplay during gestures and restarted it afterwards.
========================================================= */

(function () {
  'use strict';

  function initSlider(slider) {
    if (!slider || slider.dataset.egoHeroSliderInitialized === 'true') return;

    slider.dataset.egoHeroSliderInitialized = 'true';

    var slides = Array.prototype.slice.call(
      slider.querySelectorAll('[data-ego-hero-slide]')
    );

    if (slides.length <= 1) return;

    var track = slider.querySelector('.ego-hero-slider__track');
    var prevButton = slider.querySelector('[data-ego-hero-prev]');
    var nextButton = slider.querySelector('[data-ego-hero-next]');
    var dots = Array.prototype.slice.call(
      slider.querySelectorAll('[data-ego-hero-dot]')
    );

    var autoplay = slider.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(slider.dataset.autoplaySpeed, 10) || 6000;
    var currentIndex = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });

    if (currentIndex < 0) currentIndex = 0;

    var timer = null;
    var activePointerId = null;
    var pointerStartX = 0;
    var pointerStartY = 0;
    var isTrackingPointer = false;

    function setActiveSlide(index) {
      if (index === currentIndex) return;

      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      slides[currentIndex].classList.remove('is-active');

      if (dots[currentIndex]) {
        dots[currentIndex].classList.remove('is-active');
      }

      currentIndex = index;

      slides[currentIndex].classList.add('is-active');

      if (dots[currentIndex]) {
        dots[currentIndex].classList.add('is-active');
      }
    }

    function goNext() {
      setActiveSlide(currentIndex + 1);
    }

    function goPrev() {
      setActiveSlide(currentIndex - 1);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = window.setInterval(goNext, autoplaySpeed);
    }

    function isInteractiveTarget(target) {
      return Boolean(
        target &&
        target.closest &&
        target.closest('a, button, input, select, textarea, summary, [role="button"]')
      );
    }

    function resetPointerTracking() {
      activePointerId = null;
      pointerStartX = 0;
      pointerStartY = 0;
      isTrackingPointer = false;
    }

    function finishSwipe(endX, endY) {
      if (!isTrackingPointer || !track) return;

      var deltaX = endX - pointerStartX;
      var deltaY = endY - pointerStartY;
      var absoluteX = Math.abs(deltaX);
      var absoluteY = Math.abs(deltaY);
      var minimumDistance = Math.min(
        80,
        Math.max(44, track.getBoundingClientRect().width * 0.12)
      );
      var isHorizontalSwipe =
        absoluteX >= minimumDistance && absoluteX > absoluteY * 1.15;

      resetPointerTracking();

      if (isHorizontalSwipe) {
        if (deltaX < 0) {
          goNext();
        } else {
          goPrev();
        }
      }

      startAutoplay();
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        goPrev();
        startAutoplay();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        goNext();
        startAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.dataset.egoHeroDot, 10);
        if (!Number.isNaN(index)) {
          setActiveSlide(index);
          startAutoplay();
        }
      });
    });

    if (track && window.PointerEvent) {
      track.addEventListener('pointerdown', function (event) {
        if (
          !event.isPrimary ||
          event.pointerType === 'mouse' ||
          isInteractiveTarget(event.target)
        ) {
          return;
        }

        activePointerId = event.pointerId;
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
        isTrackingPointer = true;

        stopAutoplay();

        if (track.setPointerCapture) {
          track.setPointerCapture(event.pointerId);
        }
      });

      track.addEventListener('pointerup', function (event) {
        if (!isTrackingPointer || event.pointerId !== activePointerId) return;

        finishSwipe(event.clientX, event.clientY);

        if (
          track.releasePointerCapture &&
          track.hasPointerCapture &&
          track.hasPointerCapture(event.pointerId)
        ) {
          track.releasePointerCapture(event.pointerId);
        }
      });

      track.addEventListener('pointercancel', function (event) {
        if (!isTrackingPointer || event.pointerId !== activePointerId) return;

        resetPointerTracking();
        startAutoplay();
      });
    }

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);

    startAutoplay();

    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target && event.target.contains(slider)) {
        stopAutoplay();
        resetPointerTracking();
      }
    });
  }

  function initAllSliders() {
    var sliders = document.querySelectorAll('[data-ego-hero-slider]');
    sliders.forEach(initSlider);
  }

  document.addEventListener('DOMContentLoaded', initAllSliders);
  document.addEventListener('shopify:section:load', initAllSliders);
})();
